import React, { useEffect, useMemo, useState } from 'react';

interface Props {
  onStart: () => void;
  dadosEmpresa: any;
}

const TelaInicial: React.FC<Props> = ({ onStart, dadosEmpresa }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const destaques = useMemo(() => {
    const catalogo = dadosEmpresa?.catalogoProdutos || [];
    return catalogo.filter((p: any) => p.destaque && p.urlImagem);
  }, [dadosEmpresa]);

  useEffect(() => {
    if (destaques.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % destaques.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [destaques.length]);

  return (
    <div className="totem-tela-inicial" onClick={onStart}>
      {/* Slideshow de imagens de destaque */}
      {destaques.length > 0 && destaques.map((item: any, idx: number) => (
        <div
          key={item.id || idx}
          className={`totem-slide ${idx === currentIndex ? 'totem-slide-active' : ''}`}
          style={{ backgroundImage: `url(${item.urlImagem})` }}
        />
      ))}

      {/* Overlay escuro para legibilidade */}
      <div className="totem-slide-overlay" />

      {/* Conteúdo sobre o slideshow */}
      <div className="totem-tela-inicial-content">
        <h1 className="totem-titulo-boas-vindas">
          {dadosEmpresa?.empresaNome || 'Bem-vindo!'}
        </h1>
        <p className="totem-subtitulo">Toque na tela para começar seu pedido</p>
      </div>
    </div>
  );
};

export default TelaInicial;
